'use strict';

var jsxRuntime = require('react/jsx-runtime');
var gqlUtils = require('@liquorice/gql-utils');
var React = require('react');
var FORMIE_NESTED_ROW_FRAGMENT = require('../../gql/fragments/FORMIE_NESTED_ROW_FRAGMENT.js');
var FormieRowContainer = require('../FormieRowContainer/FormieRowContainer.js');

function _interopNamespaceDefaultOnly (e) { return Object.freeze({ __proto__: null, default: e }); }

/**
 * In order to avoid circular dependencies, we need to use React.lazy to import FormieField.
 */ const FormieField = /*#__PURE__*/ React.lazy(()=>Promise.resolve().then(function () { return /*#__PURE__*/_interopNamespaceDefaultOnly(require('../FormieField/index.js')); }));
const FormieNestedRows = gqlUtils.withFragmentArray(FORMIE_NESTED_ROW_FRAGMENT.FORMIE_NESTED_ROW_FRAGMENT, (rows, { methods, parentHandle })=>{
    if (!rows) return null;
    return /*#__PURE__*/ jsxRuntime.jsx(React.Suspense, {
        fallback: /*#__PURE__*/ jsxRuntime.jsx(jsxRuntime.Fragment, {}),
        children: rows.map((row, rowIndex)=>{
            var _row_rowFields;
            if (!row || !((_row_rowFields = row.rowFields) == null ? void 0 : _row_rowFields.length)) return null;
            var _row_id;
            return /*#__PURE__*/ jsxRuntime.jsx(FormieRowContainer, {
                marginBottom: 2,
                children: row.rowFields.map((field, i)=>{
                    var _field_id;
                    return /*#__PURE__*/ jsxRuntime.jsx(FormieField, {
                        data: field,
                        methods: methods,
                        parentHandle: parentHandle
                    }, (_field_id = field == null ? void 0 : field.id) != null ? _field_id : i);
                })
            }, (_row_id = row.id) != null ? _row_id : rowIndex);
        })
    });
});

module.exports = FormieNestedRows;
